// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file onboarding/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Quantity } from "../inventory/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.MedicalInventoryItem
 */
export class MedicalInventoryItem extends Message<MedicalInventoryItem> {
  /**
   * @generated from field: string medical_master_id = 1;
   */
  medicalMasterId = "";

  /**
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * @generated from field: string unit = 3;
   */
  unit = "";

  /**
   * @generated from field: string unit_type = 4;
   */
  unitType = "";

  /**
   * @generated from field: string barcode = 5;
   */
  barcode = "";

  /**
   * @generated from field: double vat = 6;
   */
  vat = 0;

  /**
   * @generated from field: string pharmacy_code = 7;
   */
  pharmacyCode = "";

  /**
   * @generated from field: com.neulink.pharmacy.Quantity quantity = 8;
   */
  quantity?: Quantity;

  /**
   * @generated from field: string batch_number = 9;
   */
  batchNumber = "";

  /**
   * @generated from field: string expiry_date = 10;
   */
  expiryDate = "";

  /**
   * @generated from field: double cost = 11;
   */
  cost = 0;

  /**
   * @generated from field: string production_date = 12;
   */
  productionDate = "";

  /**
   * @generated from field: string inventory_id = 13;
   */
  inventoryId = "";

  /**
   * @generated from field: double sold_quantity = 14;
   */
  soldQuantity = 0;

  /**
   * @generated from field: double available_stock = 15;
   */
  availableStock = 0;

  /**
   * @generated from field: string last_sold_date = 16;
   */
  lastSoldDate = "";

  /**
   * @generated from field: bool expired = 17;
   */
  expired = false;

  /**
   * @generated from field: int64 full_count = 18;
   */
  fullCount = protoInt64.zero;

  constructor(data?: PartialMessage<MedicalInventoryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MedicalInventoryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "medical_master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "vat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "pharmacy_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "quantity", kind: "message", T: Quantity },
    { no: 9, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "expiry_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "production_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "sold_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "available_stock", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "last_sold_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "full_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MedicalInventoryItem {
    return new MedicalInventoryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MedicalInventoryItem {
    return new MedicalInventoryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MedicalInventoryItem {
    return new MedicalInventoryItem().fromJsonString(jsonString, options);
  }

  static equals(a: MedicalInventoryItem | PlainMessage<MedicalInventoryItem> | undefined, b: MedicalInventoryItem | PlainMessage<MedicalInventoryItem> | undefined): boolean {
    return proto3.util.equals(MedicalInventoryItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.NonMedicalInventoryItem
 */
export class NonMedicalInventoryItem extends Message<NonMedicalInventoryItem> {
  /**
   * @generated from field: string non_medical_master_id = 1;
   */
  nonMedicalMasterId = "";

  /**
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * @generated from field: string unit = 3;
   */
  unit = "";

  /**
   * @generated from field: string unit_type = 4;
   */
  unitType = "";

  /**
   * @generated from field: string barcode = 5;
   */
  barcode = "";

  /**
   * @generated from field: double vat = 6;
   */
  vat = 0;

  /**
   * @generated from field: string custom_barcode = 7;
   */
  customBarcode = "";

  /**
   * @generated from field: string inventory_id = 8;
   */
  inventoryId = "";

  /**
   * @generated from field: double sold_quantity = 9;
   */
  soldQuantity = 0;

  /**
   * @generated from field: double available_stock = 10;
   */
  availableStock = 0;

  /**
   * @generated from field: string last_sold_date = 11;
   */
  lastSoldDate = "";

  /**
   * @generated from field: bool expired = 12;
   */
  expired = false;

  /**
   * @generated from field: string expiry_date = 13;
   */
  expiryDate = "";

  /**
   * @generated from field: string batch_number = 14;
   */
  batchNumber = "";

  /**
   * @generated from field: double cost = 15;
   */
  cost = 0;

  /**
   * @generated from field: string production_date = 16;
   */
  productionDate = "";

  /**
   * @generated from field: double price = 17;
   */
  price = 0;

  /**
   * @generated from field: int64 full_count = 18;
   */
  fullCount = protoInt64.zero;

  constructor(data?: PartialMessage<NonMedicalInventoryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.NonMedicalInventoryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "non_medical_master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "vat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "custom_barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "sold_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "available_stock", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "last_sold_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "expiry_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "production_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 18, name: "full_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NonMedicalInventoryItem {
    return new NonMedicalInventoryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NonMedicalInventoryItem {
    return new NonMedicalInventoryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NonMedicalInventoryItem {
    return new NonMedicalInventoryItem().fromJsonString(jsonString, options);
  }

  static equals(a: NonMedicalInventoryItem | PlainMessage<NonMedicalInventoryItem> | undefined, b: NonMedicalInventoryItem | PlainMessage<NonMedicalInventoryItem> | undefined): boolean {
    return proto3.util.equals(NonMedicalInventoryItem, a, b);
  }
}

